import METRIC_KEYS from './METRIC_KEYS'

/*
 * Constants to represent the motivations of users of Plan Builder.
 */
const MOTIVATIONS = {
    carbonSaving: METRIC_KEYS.carbonSaving,
    efficiencyImproving: 't-co2+fuel-bill',
    fuelBill: METRIC_KEYS.fuelBill,
    sapScore: METRIC_KEYS.sapScore,
    targetNetZero: 't-co2-zero',
    targetSapC: 't-sap-c',
}

/**
 * All available motivation keys as an array.
 * @type {Array<string>}
 */
const ALL_MOTIVATIONS = [
    MOTIVATIONS.carbonSaving,
    MOTIVATIONS.efficiencyImproving,
    MOTIVATIONS.fuelBill,
    MOTIVATIONS.sapScore,
    MOTIVATIONS.targetNetZero,
    MOTIVATIONS.targetSapC,
]

/**
 * Default motivation keys as an array.
 * @type {Array<string>}
 */
const DEFAULT_MOTIVATIONS = [
    MOTIVATIONS.carbonSaving,
    MOTIVATIONS.fuelBill,
    MOTIVATIONS.targetNetZero,
]

export { ALL_MOTIVATIONS, DEFAULT_MOTIVATIONS }

export default MOTIVATIONS
